import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";

import { DateAdapter, NativeDateAdapter } from '@angular/material';

import { FireDataService } from '../fire-data.service';

@Component({
  selector: 'app-case-group',
  templateUrl: './case-group.component.html',
  styleUrls: ['./case-group.component.css']
})
export class CaseGroupComponent implements OnInit, OnChanges {
  @Input() modelData;
  @Input() modelDataChanges;
  @Output()
  childClick: EventEmitter<String> = new EventEmitter<String>();

  groupForm: FormGroup;
  caseSchedule: object
  groupList: object
  row: object

  constructor(private fds: FireDataService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private location: Location, 
    dateAdapter: DateAdapter<NativeDateAdapter>) { 

    dateAdapter.setLocale('it-IT');  // for MDdatePicker
    this.row = {group: '',  startDate: new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()).valueOf(), 
                endDate: new Date(new Date().getFullYear(),new Date().getMonth() , new Date().getDate()).valueOf(), settled: false, note: ''};

    this.caseSchedule = {"show":false,"items": null, "message": ""}


  }

  ngOnInit() {
    this.initializeModel(this.row)
    this.createForm(this.modelData);
    this.sendDataToParent(this.modelData)
    this.validateGroupForm()
    this.fds.getGroupList()
    .then(res => {
      this.groupList = res
    })
  }

  ngOnChanges(changes) {
    
      if (this.modelData['inizializeModel']) {
        this.initializeModel(this.row)
        this.createForm(this.modelData);
        this.modelData['inizializeModel'] = false
        this.sendDataToParent(this.modelData)
        this.validateGroupForm()
        this.loadGroupSchedule(this.modelData['group'], this.modelData['startDate'])
        console.log("GROUP ngOnChanges ...", this.modelData, changes)
      }
      /*  Disabling form field don't work, or me don't know how to do
      if (this.modelData['disableModel'] == true) {
        console.log("DISABLING ...", this.modelData, changes)
        this.groupForm.get('group').disable()
        this.groupForm.get('startDate').disable()
        this.groupForm.get('endDate').disable()
        this.groupForm.get('settled').disable()
      } else {
        console.log("ENABLING ...", this.modelData, changes)
        this.groupForm.get('group').enable()
        this.groupForm.get('startDate').enable()
        this.groupForm.get('endDate').enable()
        this.groupForm.get('settled').enable()
      } */
  }

  private initializeModel(row) {
    for (var prop in row) {
      if(!this.modelData[prop]) {this.modelData[prop] = row[prop]}
    }
    this.caseSchedule['show'] = false
  }

  createForm(row) {
    this.groupForm = this.fb.group({
      group: row.group,
      startDate: new Date(row.startDate),
      endDate: new Date(row.endDate),
      settled: row.settled,
      note: row.note
    });
  }

  private validateGroupForm() {
    this.groupForm.get('startDate').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('startDate', val)
      if (this.groupForm.get('group').value) {
        this.groupForm.get('group').setValue(this.groupForm.get('group').value);
        this.groupForm.get('group').updateValueAndValidity();
      }
      if (val > this.groupForm.get('endDate').value) {
        this.groupForm.get('endDate').setValue(val);
        this.groupForm.get('endDate').updateValueAndValidity();
      }
    });

    this.groupForm.get('endDate').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('endDate', val)
      if (val < this.groupForm.get('startDate').value) {
        this.groupForm.get('startDate').setValue(val);
        this.groupForm.get('startDate').updateValueAndValidity();
      }
    });

    this.groupForm.get('group').valueChanges
    .subscribe(val => {
      console.log("Fire group valueChange...", val)
      if (val) {
        this.loadGroupSchedule (this.groupForm.get('group').value, this.groupForm.get('startDate').value)
        this.modelDataUpdate ('group', this.groupForm.get('group').value)
      } 
    });

    this.groupForm.get('settled').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('settled', val)
      if (!val && this.groupForm.get('group').value) {
        this.modelDataUpdate ('schedule', this.caseSchedule['items'])
      } else {this.modelDataUpdate ('schedule', '')}
      this.caseSchedule['show'] = val ? false : this.groupForm.get('group').value ? true : false
    });

    this.groupForm.get('note').valueChanges
    .subscribe(val => {
      this.modelDataUpdate ('note', val)
    });

  }

  private loadGroupSchedule(group, statDate) {
    this.fds.getGroupSchedule(group, statDate)
    .then(res => {
      this.caseSchedule['items'] = res
      this.modelDataUpdate ('teachers', [])
      this.modelDataUpdate ('showAddTeacher', true)
      this.scheduleMerge(res)
      console.log("Schedule after MERGE ...: ", this.caseSchedule['items'])
      if (!this.groupForm.get('settled').value) {
        this.caseSchedule['show'] = true
        this.modelDataUpdate ('schedule', this.caseSchedule['items'])
      } else {
        this.caseSchedule['show'] = false
        this.modelDataUpdate ('schedule', '')
      }
    })
  }

  private scheduleMerge (sched) {
    //console.log("Group schedule merge, ENTRY ..:", sched)
    var schedule = [], daySched, daySchedule, arr, itemToFind
    if (this.modelData['isEditingMode']) {
      daySched = []
      for (var s in this.modelData['classes']) {
        daySched.push({'sched': s,'group': this.modelData['classes'][s], 'value': true})
      }
      schedule.push({"day": this.fds.getDayKey(this.modelData['startDate']), "value": daySched})
      this.modelData['classes'] = []
      //console.log("Group schedule merge, SCHEDULE ..:", schedule)
    } else {
      schedule = this.modelData['schedule'] ? this.modelData['schedule'] : []
    }
    // if no previous schedule is found, sched is the schedule to return, no merge is needed
    if (schedule.length == 0) {
      this.caseSchedule['items'] = sched
      //console.log("Group schedule merge, NO SCHEDULE ..:", this.caseSchedule['items'])
      return
    } 
    // at this point sched contains all schedule for the teacher and schedule the editing one
    // so we merge schedule INTO sched
    //console.log("Group schedule merge, MERGING ..:", sched)
      for (var d in schedule) {
        itemToFind = schedule[d]['day']
        daySchedule = sched[sched.findIndex(dayIdx)]
        for (var s in schedule[d]['value']) {
          itemToFind = schedule[d]['value'][s]['sched']
          daySchedule['value'][daySchedule['value'].findIndex(schedIdx)]['value'] = schedule[d]['value'][s]['value']
        }
      }
      arr = sched
    // end of merge 
            function dayIdx (el) {
              return el.day == itemToFind
            }
            function schedIdx (el) {
              return el['sched'] == itemToFind
            }
    this.caseSchedule['items'] = arr
    //console.log("Group schedule merge, EXIT ..:", this.caseSchedule['items'])
  }

  deleteTeacher(tech){
    this.modelDataUpdate ('teachers', this.modelData['teachers'].filter(t => t.teacher !== tech))
  }

  private modelDataUpdate(field, value) {
    if (field == 'startDate' || field == 'endDate') {
      value = new Date(value.getFullYear(),value.getMonth() , value.getDate()).valueOf()
    }
    this.modelData[field] = value
    this.sendDataToParent(this.modelData)
  }

  scheduleIsChanged(par) {
    this.caseSchedule = par
    //console.log("Schedule is changed...:", this.caseSchedule['items'])
    this.sendDataToParent(this.modelData)
  }

  sendDataToParent(data) {
    //console.log("CASE-GROUP --> send to case-master...:", data)
    this.childClick.emit(data)
  }

}



// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-group/case-group.component.ts